import { useContext } from 'react';

import { LayoutContext } from '../context/layout';

export const useLayout = () => {
  const context = useContext(LayoutContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error('useLayout was used outside of its Provider');
  }

  return context;
};
